import React, { useEffect, useState } from "react";
import styles from "../common.module.css";
import { authClient } from "./defaults";

const Sessions = () => {
    const [sessions, setSessions] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [popupMessage, setPopupMessage] = useState("");
    const [showPopup, setShowPopup] = useState(false);
    
    const [isSuccess, setIsSuccess] = useState(false);
    const [showConfirmPopup, setShowConfirmPopup] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);


    useEffect(() => {
        const fetchSessions = async () => {
            try {
                let response = await authClient.get("/sessions", { withCredentials: true });

                if (response.status === 200) {
                    setSessions(response.data.sessions);
                } else {
                    setPopupMessage("Failed to load sessions.");
                    setShowPopup(true);
                }
            } catch (err) {
                console.error("Session fetch error:", err);
                setPopupMessage("Could not fetch session data.");
                setShowPopup(true);
            } finally {
                setIsLoading(false);
            }
        };

        fetchSessions();
    }, []);


    const handleDeleteSession = async (sessionId) => {
        try {
            let response = await authClient.delete(`/sessions/${sessionId}`, { withCredentials: true });

            if (response.status === 200) {
                setPopupMessage("Session successfully revoked.");
                setIsSuccess(true);
                setShowPopup(true);
            }

            setSessions((prevSessions) => {
                let updatedSessions = prevSessions.filter((session) => session.session_id !== sessionId);

                if (updatedSessions.length === 0) {
                    localStorage.clear();
                    document.cookie = "authorization=; Max-Age=0; path=/";
                    setTimeout(() => {
                        window.location.href = "/login-signup";
                    }, 2000);
                }

                return updatedSessions;
            });

        } catch (err) {
            console.error("Error deleting session:", err);
            setPopupMessage("Failed to delete session.");
            setShowPopup(true);
        }
    };

    const handleDeleteAccount = async () => {
        setPopupMessage("Are you sure you want to delete your account? This action is irreversible.");
        setShowConfirmPopup(true);
    };

    const confirmDeleteAccount = async () => {
        if (isDeleting) return;

        setIsDeleting(true);
        setShowConfirmPopup(false);

        try {
            let response = await authClient.delete("/profile", { withCredentials: true });

            if (response.status === 200) {
                setPopupMessage("Account deleted successfully!");
                setIsSuccess(true);
                setShowPopup(true);
                setTimeout(() => {
                    window.location.href = "/login-signup";
                }, 2000);
            }
        } catch (err) {
            console.error("Error deleting account:", err);
            setPopupMessage("Failed to delete account.");
            setShowPopup(true);
        } finally {
            setIsDeleting(false);
        }
    };

    const closePopup = () => {
        setShowPopup(false);
        setPopupMessage("");
        setShowConfirmPopup(false);
    };

    if (isLoading) return <div className="loading">Loading sessions...</div>;

    return (
        <div className="profile-wrapper">
            <div className="session-container">
                <h2 className="profile-header">Active Sessions</h2>
                <table className="session-table">
                    <thead>
                        <tr>
                            <th>Source (IP Address)</th>
                            <th>Agent (User Agent)</th>
                            <th>Session ID</th>
                            <th>Signed In (Started At)</th>
                            <th>Last Used (Last Accessed At)</th>
                            <th>Session Expiry</th>
                            <th>End Session</th>
                        </tr>
                    </thead>
                    <tbody>
                        {sessions.length === 0 ? (
                            <tr>
                                <td colSpan="7" className="no-sessions">No active sessions found.</td>
                            </tr>
                        ) : (
                            sessions.map((session) => (
                                <tr key={session.session_id}>
                                    <td>{session.ip_address || "Unknown"}</td>
                                    <td>{session.user_agent || "Unknown"}</td>
                                    <td>{session.session_id}</td>
                                    <td>{new Date(session.started_at).toLocaleString()}</td>
                                    <td>{new Date(session.last_accessed_at).toLocaleString()}</td>
                                    <td>{new Date(session.expires_at).toLocaleString()}</td>
                                    <td>
                                        <button
                                            className="revoke-button"
                                            onClick={() => handleDeleteSession(session.session_id)}
                                        >
                                            Revoke
                                        </button>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>

                <button className="delete-account-button" onClick={handleDeleteAccount}>
                    Delete Account
                </button>
            </div>
            {showPopup && (
                <div className={styles.popupOverlay}>
                    <div className={styles.popup}>
                        <h3>{isSuccess ? "Success" : "Error"}</h3>
                        <p>{popupMessage}</p>
                        <button onClick={closePopup} className={styles.popupButton}>
                            OK
                        </button>
                    </div>
                </div>
            )}
            {showConfirmPopup && (
                <div className={styles.popupOverlay}>
                    <div className={styles.popup}>
                        <h3>Confirm Action</h3>
                        <p>{popupMessage}</p>
                        <div className="button-container">
                            <button
                                className="delete-account-button"
                                onClick={confirmDeleteAccount}
                                disabled={isDeleting}
                            >
                                {isDeleting ? "Deleting..." : "Confirm"}
                            </button>
                            <button
                                className="delete-account-cancel-button"
                                onClick={closePopup}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}
            <div className="navbar">
                <a href="/dashboard">Home</a>
                <div className="account-container">
                    <a href="#" className="account-link">My Account</a>
                    <div className="account-dropdown">
                        <a href="/user/profile">Profile</a>
                        <a href="/user/sessions">Sessions</a>
                    </div>
                </div>
                <a href="/user/logout">Logout</a>
            </div>
        </div>
    );
};

export default Sessions;
